'use client'

import dynamic from 'next/dynamic'
import type { PropsWithChildren } from 'react'

const ModalProviderComponent = dynamic(() => import('mui-modal-provider'), { ssr: false })

export default function MuiModalProvider({ children }: PropsWithChildren) {
  return <ModalProviderComponent>{children}</ModalProviderComponent>
}
